import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { WindowRefService } from "../services/window-ref.service";

const SESSION_TOKEN_KEY: string = "LookerSessionToken";

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  constructor(private readonly windowRef: WindowRefService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(this.addHeaders(request));
  }

  private addHeaders(request: HttpRequest<any>): HttpRequest<any> {
    const globalAccount = this.windowRef.nativeWindow["GLOBAL_ACCOUNT"];
    const sessionToken = localStorage.getItem(SESSION_TOKEN_KEY);
    let req = request.clone();
    if (globalAccount?.accountId) {
      req = this.addHeader(req, "Account-Id", "" + globalAccount.accountId);
    }
    if (sessionToken) {
      req = this.addHeader(req, "SessionToken", sessionToken);
    }
    return req;
  }

  private addHeader(
    req: HttpRequest<any>,
    headerName: string,
    value: string,
  ): HttpRequest<any> {
    if (value) {
      return req.clone({
        setHeaders: {
          [headerName]: value,
        },
      });
    }
    return req;
  }
}
